import { colors } from "@styles/colors";
import { XStack, Text } from "tamagui";

export const Badge = ({ children, bg = "#efefef", color = colors.gray }: Readonly<{ children?: React.ReactNode; bg?: string; color?: string }>) => (
  <XStack
    background={bg} // 背景顏色
    br="$5" // 圓角
    ai="center" // 垂直置中
    jc="center"
    px={10}
    style={{ display: "inline-block" }}>
    <Text color={color} fontSize={12}>
      {children}
    </Text>
  </XStack>
);

export default Badge;
